<template>
    <div>
        <img :src="button.src" :alt="button.label">
        <h5 v-html="$t('NAV_BUTTON_LABEL', { 'button.label': $t(`${button.label}`)})"></h5>
    </div>
</template>
<script>
export default {
    name: 'NavButton',
    props: {
        button: {
            required: true,
            default: {},
        },
    },
};
</script>
